import { getGeolocationServiceUrl } from '@repo/dot-env/geolocation-service-url'
import { z } from '@repo/schema'

import { fetchLookup } from './lookup-result.ts'
import { googlePlaceSchema, normalizePlaceDetails } from './normalize-address.ts'

const placeDetailsSchema = z.object({ result: googlePlaceSchema.optional() })

export const getPlaceDetails = (placeId: string, serviceUrl = getGeolocationServiceUrl()) =>
  fetchLookup(
    `${serviceUrl}/google/place/details?${new URLSearchParams({ place_id: placeId })}`,
    placeDetailsSchema,
    ({ result }) => (result ? normalizePlaceDetails(result) : null),
  )
